// @core/api/endpoints/localization/update_platform_locale_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformLocaleConfigResponse,
  UpdatePlatformLocaleConfigRequest,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Update platform locale config
 * Updates the platform's locale settings.
 */
export async function UpdatePlatformLocaleConfig(
  data: UpdatePlatformLocaleConfigRequest,
  options?: RequestOptions
): Promise<PlatformLocaleConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/config`;
  const requestOptions = options;
  return client.put<PlatformLocaleConfigResponse>(requestPath, data, requestOptions);
}
